import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { reasons } from '../request/RequestRejectOrCancel';
import './AttendeeRequestReason.css';
//
// Если есть причина отказа от встречи, то показывает её в тултипе.
//
interface AttendeeRequestStatusProps {
    reason?: string|null;
};

const AttendeeRequestReason: FC<AttendeeRequestStatusProps> = ({ reason }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const [ text, setText ] = useState(reason);
    // ВНИМАНИЕ: Причина отказа хранится в одном поле, а не как в других
    // случаях - в двух полях с постфиксами _ru и _en. Вообще-то это надо бы
    // переделать для общего единообразия, но клиент при составлении ТЗ
    // обозначил только одно поле для ввода текста отказа, а не два (как в других случаях).
    // При этом клиент при приёмке захотел чтобы типовые варианты отказа
    // отображались на языке пользователя. Поэтому тут мы устраиваем колхоз для
    // подстановки текста типового отказа на нужном языке.
    useEffect(() => {
        if(reason === reasons[0].name_ru && lang === 'en') {
            setText(reasons[0].name_en);
        } else if (reason === reasons[0].name_en && lang === 'ru') {
            setText(reasons[0].name_ru);
        } else if (reason === reasons[1].name_ru && lang === 'en') {
            setText(reasons[1].name_en);
        } else if (reason === reasons[1].name_en && lang === 'ru') {
            setText(reasons[1].name_ru);
        } else {
            setText(reason);
        }
    }, [ reason, lang ]);

    if(!text) return null;

    return (
        <div className="AttendeeRequestReason">
            {t('attendee.reason')}
            <div className="Reason">{text}</div>
        </div>
    );
};

export default AttendeeRequestReason;
